import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const messageTypeEntityName = 'messageType';
const messageTypeColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { alertInfo: {
        type: 'string',
    }, displayOrder: {
        type: 'number',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineMessageTypeClassifier(defaultData) {
    return defineClassifierEntity({
        entity: {
            version: 2,
            columns: messageTypeColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { name: params.data.name, alertInfo: params.data.alertInfo, displayOrder: params.data.displayOrder, search: [params.data.name, params.data.alertInfo, params.data.status, params.data.displayOrder].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (userState.systemRole !== 'system-admin') {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData,
    });
}
